import { buttonDefaults } from './button';

// https://www.figma.com/design/aSILY4jOBvdU3l6DuL4k5j/Design-System?node-id=2872-13320&m=dev
export const squareButtonDefaults = {
  ...buttonDefaults,
  rounded: 'sm',
};
